<form *ngIf="form" [formGroup]="form">
  <div class="tw-flex tw-gap-x-8">
    <mat-form-field>
      <mat-label>{{ 'common.field.email' | translate }}*</mat-label>
      <input matInput (blur)="onEmailBlurEvent()" formControlName="email" />
      <mat-error>
        <ui-field-error-messages [control]="form.get('email')"></ui-field-error-messages>
      </mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'common.field.department' | translate }}</mat-label>
      <input matInput formControlName="department" />
    </mat-form-field>
  </div>

  <div class="tw-flex tw-gap-x-8">
    <mat-form-field>
      <mat-label>{{ 'common.field.firstName' | translate }}*</mat-label>
      <input matInput formControlName="firstName" />
      <mat-error>
        <ui-field-error-messages [control]="form.get('firstName')"></ui-field-error-messages>
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'common.field.lastName' | translate }}*</mat-label>
      <input matInput formControlName="lastName" />
      <mat-error>
        <ui-field-error-messages [control]="form.get('lastName')"></ui-field-error-messages>
      </mat-error>
    </mat-form-field>
  </div>

  <div class="tw-flex tw-gap-x-8">
    <div class="tw-basis-full">
      <ui-select-search
        [selectControl]="form.get('country')"
        [optionItems]="countries"
        [placeholderName]="('common.field.country' | translate) + '*'"
        [noEntriesFoundLabel]="'common.message.noCountriesFound' | translate"
      >
      </ui-select-search>
      <mat-error *ngIf="form.get('country').touched">
        <ui-field-error-messages [control]="form.get('country')"></ui-field-error-messages>
      </mat-error>
    </div>
    <mat-form-field>
      <mat-label>{{ 'common.field.defaultLanguage' | translate }}*</mat-label>
      <mat-select formControlName="defaultLanguage">
        <mat-option *ngFor="let language of languageList" [value]="language">
          {{ 'common.language.' + language.toLowerCase() | translate }}
        </mat-option>
      </mat-select>
      <mat-error>
        <ui-field-error-messages [control]="form.get('defaultLanguage')"></ui-field-error-messages>
      </mat-error>
    </mat-form-field>
  </div>

  <div class="tw-flex tw-gap-x-8">
    <mat-form-field>
      <mat-label>{{ 'common.field.timezone' | translate }}*</mat-label>
      <mat-select formControlName="timezone">
        <mat-option *ngFor="let zone of timezoneList" [value]="zone.utc[0]">
          {{ zone.text }}
        </mat-option>
      </mat-select>
      <mat-error>
        <ui-field-error-messages [control]="form.get('timezone')"></ui-field-error-messages>
      </mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-select formControlName="unitSystem">
        <mat-option *ngFor="let unitSystem of unitSystemValues" [value]="unitSystem">
          {{ 'administration.user.item.unitSystem.' + unitSystem | translate }}
        </mat-option>
      </mat-select>
      <mat-error>
        <ui-field-error-messages [control]="form.get('unitSystem')"></ui-field-error-messages>
      </mat-error>
    </mat-form-field>
  </div>
</form>
